import { parse } from 'hub-http/helpers/params';
export const getQueryParam = param => {
  // Accessing `window.top` throws when we're on a
  // different domain (e.g. Wordpress)
  try {
    return parse(window.top.location.search.substring(1))[param];
  } catch (_) {
    return '';
  }
};
export const getHasAcceptanceTestOverride = () => {
  return getQueryParam('isAcceptanceTest') === 'true';
};